import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './CricketScorecardV2.scss';

class Bowling extends React.Component {
  render() {
    const { bowlers, isWapView } = this.props;

    return (
      bowlers &&
      bowlers.map && (
        <div className={`${s.scorecardTable} ${s.bowlingTable}`}>
          <ul>
            <li className={s.tableHeading}>
              <span className={`${s.name} ${s.text}`}>Bowler</span>
              <span className={s.text}>O</span>
              <span className={s.text}>M</span>
              <span className={s.text}>R</span>
              <span className={s.text}>W</span>
              <span className={s.text}>Ec</span>
              {!isWapView ? <span className={s.text}>Wd</span> : ''}
              {!isWapView ? <span className={s.text}>NB</span> : ''}
            </li>
            {bowlers.map &&
              bowlers.map(bowler => (
                <li
                  data-bowler-id={bowler.name}
                  className={classNames({
                    [`${s.tableItem}`]: true,
                    [`${s.bowling}`]: bowler.bowling === 'Yes',
                    [`${s.bowlerin}`]: bowler.issupersub,
                    [`${s.bowlerout}`]: bowler.is_substituted,
                  })}
                  key={bowler.name}
                >
                  <span className={`${s.name} ${s.text}`}>
                    <Link to={bowler.link} target="_blank">
                      {bowler.name}
                    </Link>
                  </span>
                  <span className={s.text}>{bowler.overs}</span>
                  <span className={s.text}>{bowler.maidens}</span>
                  <span className={s.text}>{bowler.runsGiven}</span>
                  <span className={s.text}>{bowler.wickets}</span>
                  <span className={s.text}>{bowler.econ}</span>
                  {!isWapView ? (
                    <span className={s.text}>{bowler.wides}</span>
                  ) : (
                    ''
                  )}
                  {!isWapView ? (
                    <span className={s.text}>{bowler.noBalls}</span>
                  ) : (
                    ''
                  )}
                </li>
              ))}
          </ul>
        </div>
      )
    );
  }
}

Bowling.propTypes = {
  bowlers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Bowling;
